import React, {useRef} from "react";
import { connect } from "react-redux";

import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import IconButton from "@mui/material/IconButton";
import {setLookActiveCategory} from "../../../../../actions/lookFunctions";

const SLIDE_DIRECTIONS = {
  left: "left",
  right: "right"
}

const GroheRequiredFeatures = (props) => {
  const {requiredFeatures} = props;
  const sliderRef = useRef(null);

  const handleScrollClick = (direction) => {
    switch (direction) {
      case SLIDE_DIRECTIONS.left: sliderRef.current.scrollLeft += 94
        break
      case SLIDE_DIRECTIONS.right: sliderRef.current.scrollLeft -= 94
        break
    }
  };


  if (!requiredFeatures) {
    return null
  }

  return (
    <div className="required-feature__slider">
      {
        requiredFeatures.length > 1
          ? <IconButton onClick={() => { handleScrollClick(SLIDE_DIRECTIONS.right) }}
                      className="look-icon look-icon--small">
            <KeyboardArrowLeftIcon/>
          </IconButton>
          : null
      }
      <div className="required-feature__list" ref={sliderRef}>
        <div className="required-feature__list-container">
          {
            requiredFeatures.map((feature, index) => {
              return (
                <div className="required-feature__item" key={index}>
                  <div className="required-feature__item-image"  >
                    <LookFeatureImage forFeature={feature} withoutGallery={true}/>
                  </div>
                  {
                    index < requiredFeatures.length - 1 ? <div className="required-feature__item-icon"><AddIcon/></div>: null
                  }
                </div>
              )
            })
          }
        </div>
      </div>
      {
        requiredFeatures.length > 1
          ? <IconButton onClick={() => { handleScrollClick(SLIDE_DIRECTIONS.left) }}
                        className="look-icon look-icon--small">
            <KeyboardArrowRightIcon/>
          </IconButton>
          : null
      }
    </div>
  )
};

const mapStateToProps = () => {
  return {}
};

const mapDispatchToProps = {
  setLookActiveCategory
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheRequiredFeatures);
